/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Device_This_OneInputs */

const th_device_this_one = /** @type {(inputs: Device_This_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · อุปกรณ์นี้`)
};

const en_device_this_one = /** @type {(inputs: Device_This_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · this device`)
};

const ja_device_this_one = /** @type {(inputs: Device_This_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · この端末`)
};

const zh_device_this_one = /** @type {(inputs: Device_This_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · 本设备`)
};

const es_device_this_one = /** @type {(inputs: Device_This_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · este dispositivo`)
};

const pt_device_this_one = /** @type {(inputs: Device_This_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · este dispositivo`)
};

const id_device_this_one = /** @type {(inputs: Device_This_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · perangkat ini`)
};

const fr_device_this_one = /** @type {(inputs: Device_This_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · cet appareil`)
};

const tl_device_this_one = /** @type {(inputs: Device_This_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · ang device na ito`)
};

const vi_device_this_one = /** @type {(inputs: Device_This_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · thiết bị này`)
};

const ko_device_this_one = /** @type {(inputs: Device_This_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · 이 기기`)
};

const de_device_this_one = /** @type {(inputs: Device_This_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · dieses Gerät`)
};

const ru_device_this_one = /** @type {(inputs: Device_This_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · это устройство`)
};

const tr_device_this_one = /** @type {(inputs: Device_This_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · bu cihaz`)
};

const it_device_this_one = /** @type {(inputs: Device_This_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · questo dispositivo`)
};

const pl_device_this_one = /** @type {(inputs: Device_This_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · to urządzenie`)
};

const uk_device_this_one = /** @type {(inputs: Device_This_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · цей пристрій`)
};

const hi_device_this_one = /** @type {(inputs: Device_This_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · यह उपकरण`)
};

const ar_device_this_one = /** @type {(inputs: Device_This_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · هذا الجهاز`)
};

const ms_device_this_one = /** @type {(inputs: Device_This_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · peranti ini`)
};

const bn_device_this_one = /** @type {(inputs: Device_This_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · এই যন্ত্র`)
};

const zh_tw2_device_this_one = /** @type {(inputs: Device_This_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · 這台裝置`)
};

const zh_hk2_device_this_one = /** @type {(inputs: Device_This_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · 這台裝置`)
};

const ur_device_this_one = /** @type {(inputs: Device_This_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · یہ آلہ`)
};

const fa_device_this_one = /** @type {(inputs: Device_This_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · همین دستگاه`)
};

const sw_device_this_one = /** @type {(inputs: Device_This_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · kifaa hiki`)
};

const nl_device_this_one = /** @type {(inputs: Device_This_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · dit apparaat`)
};

/**
* | output |
* | --- |
* | "· this device" |
*
* @param {Device_This_OneInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const device_this_one = /** @type {((inputs?: Device_This_OneInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Device_This_OneInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_device_this_one(inputs)
	if (locale === "ja") return ja_device_this_one(inputs)
	if (locale === "zh") return zh_device_this_one(inputs)
	if (locale === "es") return es_device_this_one(inputs)
	if (locale === "pt") return pt_device_this_one(inputs)
	if (locale === "id") return id_device_this_one(inputs)
	if (locale === "fr") return fr_device_this_one(inputs)
	if (locale === "tl") return tl_device_this_one(inputs)
	if (locale === "vi") return vi_device_this_one(inputs)
	if (locale === "ko") return ko_device_this_one(inputs)
	if (locale === "de") return de_device_this_one(inputs)
	if (locale === "ru") return ru_device_this_one(inputs)
	if (locale === "tr") return tr_device_this_one(inputs)
	if (locale === "it") return it_device_this_one(inputs)
	if (locale === "pl") return pl_device_this_one(inputs)
	if (locale === "uk") return uk_device_this_one(inputs)
	if (locale === "hi") return hi_device_this_one(inputs)
	if (locale === "ar") return ar_device_this_one(inputs)
	if (locale === "ms") return ms_device_this_one(inputs)
	if (locale === "bn") return bn_device_this_one(inputs)
	if (locale === "zh-TW") return zh_tw2_device_this_one(inputs)
	if (locale === "zh-HK") return zh_hk2_device_this_one(inputs)
	if (locale === "ur") return ur_device_this_one(inputs)
	if (locale === "fa") return fa_device_this_one(inputs)
	if (locale === "sw") return sw_device_this_one(inputs)
	if (locale === "nl") return nl_device_this_one(inputs)
	return en_device_this_one(inputs)
});